package com.starparty.app.astro0.celestialbodies

import com.starparty.app.astro0.MathD
import com.starparty.app.astro0.SP_Colour

internal class Jupiter(sun: Sun) :
    Planet(sun) {
    private val DEF_JUPITER_COLOR = SP_Colour(201, 144, 57, 255)
    protected var mSaturn: Saturn? = null
    fun setSaturn(s: Saturn) {
        mSaturn = s
    }

    override fun addPerturbations() {
        super.addPerturbations()
        val Mj = mOEs[M]
        val Ms = mSaturn!!.mOEs[M]
        mlonEcl = mlonEcl + -0.332 * MathD.sinD(2 * Mj - 5 * Ms - 67.6)
        mlonEcl = mlonEcl + -0.056 * MathD.sinD(2 * Mj - 2 * Ms + 21)
        mlonEcl = mlonEcl + +0.042 * MathD.sinD(3 * Mj - 5 * Ms + 21)
        mlonEcl = mlonEcl + -0.036 * MathD.sinD(Mj - 2 * Ms)
        mlonEcl = mlonEcl + +0.022 * MathD.cosD(Mj - Ms)
        mlonEcl = mlonEcl + +0.023 * MathD.sinD(2 * Mj - 3 * Ms + 52)
        mlonEcl = mlonEcl + -0.016 * MathD.sinD(Mj - 5 * Ms - 69)
    }

    init {
        rgbColour = DEF_JUPITER_COLOR
        name = "Jupiter"
        abbrevName = "\u2643"
        setOrbitalElementsData(OE_JUPITER)
    }
}